import {
  FETCH_BRANDING_REQUEST,
  FETCH_BRANDING_SUCCEEDED,
  FETCH_BRANDING_FAILED,
  UPDATE_LOGO_REQUEST,
  UPDATE_LOGO_SUCCEEDED,
  UPDATE_LOGO_FAILED
} from '../actions/brandingActions'
import uniq from 'lodash/uniq'

const initialState = {
  ids: [],
  isLoading: null,
  isUploadingImage: false
}

export default function brandings(state = initialState, action) {
  switch (action.type) {
    case FETCH_BRANDING_REQUEST:
      return { ...state, isLoading: true }
    case FETCH_BRANDING_FAILED:
      return { ...state, isLoading: false }
    case FETCH_BRANDING_SUCCEEDED:
      return {
        ...state,
        isLoading: false,
        ids: uniq([...state.ids, action.response.result])
      }
    case UPDATE_LOGO_REQUEST:
      return { ...state, isUploadingImage: true }
    case UPDATE_LOGO_SUCCEEDED:
    case UPDATE_LOGO_FAILED:
      return { ...state, isUploadingImage: false }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../src/reducers/brandings.js